export default "__VITE_ASSET__b7a113ca__"